import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type { PackBase, PackCreatePayload, PackUpdatePayload, PackItem, PackItemListParams } from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/pack`;

export const getList = async (params?: RequestParams): Promise<ApiResponseList<PackBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<PackBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<PackBase>> => {
  const { data } = await axiosInstance.get<ApiResponse<PackBase>>(`${BASE}/show`, { params: { id } });
  return data;
};

export const create = async (payload: PackCreatePayload): Promise<ApiResponse<PackBase>> => {
  const { data } = await axiosInstance.post<ApiResponse<PackBase>>(`${BASE}/create`, payload);
  return data;
};

export const update = async (payload: PackUpdatePayload): Promise<ApiResponse<PackBase>> => {
  const { data } = await axiosInstance.post<ApiResponse<PackBase>>(`${BASE}/update`, payload);
  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/delete`, { id });
  return data;
};

export const getItemList = async (params?: PackItemListParams): Promise<ApiResponse<PackItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<PackItem[]>>(`${BASE}/item-list`, { params });
  return data;
};
